(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-header"]) return;
  try {
    
if (!customElements.get('atelier-navigation')) {
  customElements.define('atelier-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-atelier-cart-open]');
        if (!trigger || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        const drawer = document.querySelector('theme-drawer#cart-drawer');
        if (typeof drawer?.open !== 'function') return;
        event.preventDefault();
        drawer.open();
      }, { signal });
      const syncExpanded = event => {
        if (event.target.id !== 'cart-drawer') return;
        this.querySelector('[data-atelier-cart-open]')?.setAttribute('aria-expanded', String(event.target.hasAttribute('open')));
      };
      document.addEventListener('theme-drawer:open', syncExpanded, { signal });
      document.addEventListener('theme-drawer:close', syncExpanded, { signal });
      import('@shopify/events').then(({ StandardEvents }) => {
        if (signal.aborted) return;
        document.addEventListener(StandardEvents.cartLinesUpdate, event => {
          const sourceDialog = event.action === 'add' && event.target instanceof Element ? event.target.closest('.at-dialog') : null;
          event.promise?.then(({ cart, detail }) => {
            if (signal.aborted) return;
            const count = cart?.totalQuantity;
            if (Number.isInteger(count)) {
              this.querySelectorAll('[data-atelier-cart-count]').forEach(node => { node.textContent = String(count); });
            }
            if (!detail?.didError && sourceDialog?.open && document.querySelector('cart-drawer-component[auto-open]')) sourceDialog.close();
          }).catch(() => {});
        }, { signal });
      }).catch(() => {});
      const menu = this.querySelector('.atelier-mobile-nav');
      if (!menu) return;
      this.addEventListener('click', event => {
        if (event.target.closest('.atelier-mobile-nav a')) menu.open = false;
      }, { signal });
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) menu.open = false;
      }, { signal });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menu.open) {
          menu.open = false;
          menu.querySelector('summary').focus();
        }
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('craftluxe-atelier')) {
  customElements.define('craftluxe-atelier', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.pointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.dialogOpeners = new WeakMap();
      this.sceneRequest = 0;
      const signal = this.controller.signal;
      const filters = this.querySelector('[data-product-filters]');
      if (filters) filters.hidden = false;
      const countOutput = this.querySelector('[data-product-filter-count]');
      if (countOutput) countOutput.textContent = countOutput.dataset.countTemplate.replace('[count]', String(this.querySelectorAll('.at-selection [data-product-group]').length));
      this.querySelectorAll('[data-shelf-controls]').forEach((controls) => {
        const shelf = controls.closest('[data-product-shelf]');
        const rail = shelf?.querySelector('[data-shelf-rail]');
        if (!rail) return;
        const update = () => {
          const distance = rail.scrollWidth - rail.clientWidth;
          const position = Math.abs(rail.scrollLeft);
          controls.hidden = distance < 2;
          controls.querySelector('[data-shelf-direction="-1"]').disabled = position < 2;
          controls.querySelector('[data-shelf-direction="1"]').disabled = position >= distance - 2;
        };
        controls.addEventListener('click', (event) => {
          const button = event.target.closest('[data-shelf-direction]');
          if (!button) return;
          rail.scrollBy({ left: Number(button.dataset.shelfDirection) * rail.clientWidth * 0.8 * (getComputedStyle(rail).direction === 'rtl' ? -1 : 1), behavior: this.motionQuery.matches ? 'instant' : 'smooth' });
        }, { signal });
        rail.addEventListener('scroll', update, { passive: true, signal });
        window.addEventListener('resize', update, { passive: true, signal });
        update();
      });
      this.addEventListener('click', (event) => {
        const button = event.target.closest?.('[data-product-filter]');
        if (!button || !this.contains(button)) return;
        this.querySelectorAll('[data-product-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        let count = 0;
        this.querySelectorAll('.at-selection [data-product-group]').forEach(item => {
          item.hidden = button.dataset.productFilter !== 'all' && item.dataset.productGroup !== button.dataset.productFilter;
          if (!item.hidden) { count++; this.showReveal(item); }
        });
        const output = this.querySelector('[data-product-filter-count]');
        if (output) output.textContent = output.dataset.countTemplate.replace('[count]', String(count));
        this.scheduleProgress();
      }, { signal });
      this.addEventListener('click', (event) => this.onClick(event), { signal });
      this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
      this.addEventListener('input', (event) => {
        if (event.target.matches('[data-light-range]')) this.setLight(event.target);
      }, { signal });
      document.addEventListener('click', (event) => {
        const related = event.target.closest?.('[data-hotspot], [data-hotspot-panel]');
        if (!related || !this.contains(related)) this.closeHotspots();
      }, { signal });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        this.closeHotspots(true);
        this.setMenu(false, true);
      }, { signal });
      this.querySelectorAll('dialog').forEach((dialog) => {
        dialog.addEventListener('close', () => {
          const opener = this.dialogOpeners.get(dialog);
          if (opener?.isConnected) opener.focus({ preventScroll: true });
        }, { signal });
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }, { signal });
      });
      this.querySelectorAll('[data-parallax]').forEach((element) => {
        element.addEventListener('pointermove', (event) => {
          if (this.motionQuery.matches || !this.pointerQuery.matches) return;
          const bounds = element.getBoundingClientRect();
          if (!bounds.width || !bounds.height) return;
          const x = Math.max(-6, Math.min(6, ((event.clientX - bounds.left) / bounds.width - 0.5) * 12));
          const y = Math.max(-6, Math.min(6, ((event.clientY - bounds.top) / bounds.height - 0.5) * 12));
          element.style.setProperty('--pointer-x', `${x.toFixed(2)}px`);
          element.style.setProperty('--pointer-y', `${y.toFixed(2)}px`);
        }, { passive: true, signal });
        element.addEventListener('pointerleave', () => this.resetParallax(element), { passive: true, signal });
      });
      this.motionQuery.addEventListener('change', () => this.setMotion(), { signal });
      this.pointerQuery.addEventListener('change', () => {
        this.querySelectorAll('[data-parallax]').forEach((element) => this.resetParallax(element));
      }, { signal });
      this.scrollContainer = this.closest('.page-wrapper');
      this.scrollContainer?.addEventListener('scroll', () => this.scheduleProgress(), { passive: true, signal });
      window.addEventListener('scroll', () => this.scheduleProgress(), { passive: true, signal });
      window.addEventListener('resize', () => this.scheduleProgress(), { passive: true, signal });
      this.addEventListener('load', () => this.scheduleProgress(), { capture: true, signal });
      if ('ResizeObserver' in window) {
        this.sizeObserver = new ResizeObserver(() => this.scheduleProgress());
        this.sizeObserver.observe(this);
      }
      const selected = this.querySelector('[data-scene-tab][aria-selected="true"]') || this.querySelector('[data-scene-tab]');
      if (selected) this.setScene(selected.dataset.sceneTab, false);
      this.querySelectorAll('[data-light-range]').forEach((range) => this.setLight(range));
      this.closeHotspots();
      this.setMenu(false);
      this.setMotion();
      this.dataset.enhanced = 'true';
      this.scheduleProgress();
    }

    disconnectedCallback() {
      this.sceneRequest += 1;
      this.transition?.skipTransition();
      this.controller?.abort();
      this.controller = null;
      this.revealObserver?.disconnect();
      this.sizeObserver?.disconnect();
      cancelAnimationFrame(this.progressFrame);
      this.progressFrame = null;
      this.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
      this.querySelectorAll('[data-reveal]').forEach((element) => this.showReveal(element));
      this.querySelectorAll('[data-parallax]').forEach((element) => this.resetParallax(element));
      delete this.dataset.enhanced;
    }

    onClick(event) {
      const target = event.target.closest?.('[data-scene-tab], [data-hotspot], [data-product-dialog-open], [data-dialog-close], [data-drawer-toggle], [data-mobile-menu] a');
      if (!target || !this.contains(target)) return;
      if (target.matches('[data-scene-tab]')) {
        this.setScene(target.dataset.sceneTab, true);
      } else if (target.matches('[data-hotspot]')) {
        const panel = this.controlledPanel(target, '[data-hotspot-panel]');
        if (!panel) return;
        const shouldOpen = panel.hidden;
        this.closeHotspots();
        panel.hidden = !shouldOpen;
        target.setAttribute('aria-expanded', String(shouldOpen));
      } else if (target.matches('[data-product-dialog-open]')) {
        const id = target.dataset.productDialogOpen.replace(/^#/, '') || target.getAttribute('aria-controls');
        const dialog = Array.from(this.querySelectorAll('dialog')).find((item) => item.id === id);
        if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;
        this.closeHotspots();
        this.dialogOpeners.set(dialog, target);
        dialog.showModal();
      } else if (target.matches('[data-dialog-close]')) {
        target.closest('dialog')?.close();
      } else if (target.matches('[data-drawer-toggle]')) {
        this.setMenu(target.getAttribute('aria-expanded') !== 'true');
      } else if (target.closest('[data-mobile-menu]')) {
        this.setMenu(false);
      }
    }

    onKeydown(event) {
      const tab = event.target.closest?.('[data-scene-tab]');
      if (!tab || !this.contains(tab)) return;
      const keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
      if (!keys.includes(event.key)) return;
      const tabs = Array.from(this.querySelectorAll('[data-scene-tab]')).filter((item) => !item.disabled);
      const index = tabs.indexOf(tab);
      let next = index;
      if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else next = (index + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1) + tabs.length) % tabs.length;
      event.preventDefault();
      tabs[next]?.focus({ preventScroll: true });
      if (tabs[next]) this.setScene(tabs[next].dataset.sceneTab, true);
    }

    setScene(scene, animate) {
      if (!Array.from(this.querySelectorAll('[data-scene-panel]')).some((panel) => panel.dataset.scenePanel === scene)) return;
      const request = ++this.sceneRequest;
      const lifecycle = this.controller;
      this.transition?.skipTransition();
      const update = () => {
        if (!this.isConnected || this.controller !== lifecycle || request !== this.sceneRequest) return;
        this.closeHotspots();
        this.dataset.scene = scene;
        this.querySelectorAll('[data-scene-tab]').forEach((tab) => {
          const active = tab.dataset.sceneTab === scene;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.querySelectorAll('[data-scene-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.scenePanel !== scene;
        });
        this.scheduleProgress();
      };
      if (animate && !this.motionQuery.matches && typeof document.startViewTransition === 'function') {
        try {
          this.transition = document.startViewTransition(update);
          this.transition.ready.catch(() => {});
          this.transition.finished.catch(() => {});
        } catch {
          update();
        }
      } else update();
    }

    setLight(range) {
      const parsed = Number(range.value);
      const value = Number.isFinite(parsed) ? Math.max(0, Math.min(100, parsed)) : 100;
      this.style.setProperty('--scene-dim', String((1 - value / 100) * 0.52));
      this.querySelectorAll('[data-light-value]').forEach((label) => { label.textContent = `${Math.round(value)}%`; });
    }

    controlledPanel(control, selector) {
      const id = control.getAttribute('aria-controls');
      return Array.from(this.querySelectorAll(selector)).find((panel) => panel.id === id);
    }

    closeHotspots(restoreFocus = false) {
      const active = this.querySelector('[data-hotspot][aria-expanded="true"]');
      this.querySelectorAll('[data-hotspot]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
      this.querySelectorAll('[data-hotspot-panel]').forEach((panel) => { panel.hidden = true; });
      if (restoreFocus && active) active.focus({ preventScroll: true });
    }

    setMenu(open, restoreFocus = false) {
      const menu = this.querySelector('[data-mobile-menu]');
      const toggles = this.querySelectorAll('[data-drawer-toggle]');
      if (!menu) return;
      const wasOpen = !menu.hidden;
      menu.hidden = !open;
      toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', String(open)));
      if (!open && wasOpen && restoreFocus) toggles[0]?.focus({ preventScroll: true });
    }

    resetParallax(element) {
      element.style.setProperty('--pointer-x', '0px');
      element.style.setProperty('--pointer-y', '0px');
    }

    showReveal(element) {
      element.dataset.revealState = 'visible';
      element.classList.add('is-visible');
    }

    setMotion() {
      this.revealObserver?.disconnect();
      this.dataset.motion = this.motionQuery.matches ? 'off' : 'on';
      this.querySelectorAll('[data-parallax]').forEach((element) => this.resetParallax(element));
      const items = this.querySelectorAll('[data-reveal]');
      if (this.motionQuery.matches || !('IntersectionObserver' in window)) {
        this.transition?.skipTransition();
        items.forEach((element) => this.showReveal(element));
        return;
      }
      this.revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.showReveal(entry.target);
          this.revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0, rootMargin: '0px 0px -32px 0px' });
      items.forEach((element) => {
        if (element.dataset.revealState === 'visible' || element.getBoundingClientRect().top < window.innerHeight - 32) {
          this.showReveal(element);
        } else {
          element.dataset.revealState = 'pending';
          element.classList.remove('is-visible');
          this.revealObserver.observe(element);
        }
      });
    }

    scheduleProgress() {
      if (this.progressFrame || !this.isConnected) return;
      this.progressFrame = requestAnimationFrame(() => {
        this.progressFrame = null;
        const wrapper = this.scrollContainer;
        const ownScroll = wrapper && /(auto|scroll)/.test(getComputedStyle(wrapper).overflowY) && wrapper.scrollHeight > wrapper.clientHeight + 1;
        const page = ownScroll ? wrapper : document.documentElement;
        const distance = page.scrollHeight - page.clientHeight;
        const offset = ownScroll ? wrapper.scrollTop : window.scrollY;
        const value = distance > 0 ? Math.max(0, Math.min(1, offset / distance)) : 0;
        this.querySelectorAll('[data-scroll-progress]').forEach((line) => { line.style.transform = `scaleX(${value.toFixed(4)})`; });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelier-product-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelier-product-guide')) {
  customElements.define('atelier-product-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.tabs = [...this.querySelectorAll('[data-guide-tab]')];
      this.panels = [...this.querySelectorAll('[data-guide-panel]')];
      const tablist = this.querySelector('[data-guide-tabs]');
      if (!tablist || !this.tabs.length) return;
      tablist.hidden = false;
      this.panels.forEach(panel => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', this.tabs.find(tab => tab.dataset.guideTab === panel.dataset.guidePanel)?.id || '');
        panel.tabIndex = 0;
      });
      this.select(this.tabs[0]);
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-guide-tab]');
        if (tab && this.contains(tab)) this.select(tab);
      }, { signal });
      tablist.addEventListener('keydown', event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0 || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + (['ArrowRight','ArrowDown'].includes(event.key) ? 1 : -1) + this.tabs.length) % this.tabs.length;
        this.tabs[next].focus();
        this.select(this.tabs[next]);
      }, { signal });
    }
    select(tab) {
      this.tabs.forEach(item => { item.setAttribute('aria-selected', String(item === tab)); item.tabIndex = item === tab ? 0 : -1; });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.guidePanel !== tab.dataset.guideTab; });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
